module.exports = __webpack_public_path__ + "static/media/twitter-icon.2a03e0ae.svg";